import React, {useState, useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {TextField, Autocomplete, InputAdornment} from "@mui/material";
import search from '../../assets/images/icon-search.svg'
import {searchStock} from "../../apis/news_service";


const SearchStock = () => {
    const navigate = useNavigate();

    const [stockList, setStockList] = useState([]); // 종목 검색리스트
    const [targetStock, setTargetStock] = useState(null); //검색할 종목명
    const [stockNewsList, setStockNewsList] = useState([]); // 종목명 관련 뉴스리스트

    // 종목 입력 시 검색 자동완성 함수
    const insertStockName = (e) => {
        searchStock(e.target.value).then(res => {
            if (!!res) {
                setStockList(res);
            }
        })
            .catch((err) => console.log(err.message));
    };


    // 종목 검색 후 뉴스 호출 함수
    useEffect(() => {
        if (targetStock !== null) {
            navigate(`/news/stock/${targetStock.stockcode}`, {
                state: {type: 'stock',range: targetStock.stockcode, title: targetStock.stockname}
            })
            window.location.reload()
        }
    }, [targetStock]);

    return (
            <Autocomplete
                id="combo-box-demo"
                sx={{display:'inline-block',width: "320px", borderRadius: "20px", border: '1px solid #eee', fontSize: "18px", paddingLeft: "10px", backgroundColor: "rgba(255,255,255,0.2)", verticalAlign: "middle",}}
                onChange={(event, newValue) => setTargetStock(newValue)}
                options={stockList}
                getOptionLabel={(stock) => stock.synonym}
                renderOption={(props, stock) => <li {...props} key={stock.stockcode + Math.random()}>{stock.stockname}</li>}
                renderInput={(params) => (
                    <TextField {...params} variant="standard" placeholder="search" onChange={insertStockName}
                              InputProps={{
                              ...params.InputProps,
                                  disableUnderline: true,
                                  startAdornment: <InputAdornment position="start"><img src={search} alt='검색' /></InputAdornment>
                        }}
                    />
                )}
            />
    );
};

export default SearchStock;